import React, { useState } from "react";
import { Image, Container, Navbar, Nav } from "react-bootstrap";
import styles from "./index.module.css";
import * as Scroll from "react-scroll";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
const HeaderBar = () => {
  const imgCDNUrl = process.env.REACT_APP_CDN_URL;
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = (scrollToFunc) => {
    scrollToFunc();
    setExpanded(false); // Close the menu after clicking a link
  };

  return (
    <>
    <Navbar
      className={`${styles.nav_all}`}
      fixed="top"
      expand="lg"
      expanded={expanded}
    >
      <Container fluid className={`${styles.header_container}`}>
        <a href="http://tacanow.org" target="_blank" rel="noopener noreferrer">
          <Image
            src={imgCDNUrl + "header_new/taca_logo.svg"}
            alt="TACA Logo"
            fluid
            className={`${styles.header_image} ${styles.taca_logo}`}
          />
        </a>

        <div className={`${styles.nav_burger_wrapper}`}>
        <a
            href="https://www.swmc.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src={imgCDNUrl + "header_new/sunwest_logo.svg"}
              fluid
              className={`${styles.header_image} ${styles.sunwest_logo} ${styles.sunwest_logo_mobile}`}
              alt="Sun West Logo"
            />
          </a>
          <Navbar.Toggle
            className={`${styles.nav_burger}`}
            aria-controls="top_nav"
            onClick={() => setExpanded(expanded ? false : "expanded")}
          />
        </div>
        <Navbar.Collapse id="top_nav">
          <Nav className={`${styles.link_wrapper}`}>
            <Nav.Link
              className={`${styles.home_link}`}
              onClick={() => handleNavClick(() => {
                Scroll.animateScroll.scrollToTop({
                  duration: 500,
                  smooth: "easeInOutQuad",
                });
              })}
            >
              Home
            </Nav.Link>
            <Nav.Link
              className={`${styles.nav_link}`}
              onClick={() => handleNavClick(() => {
                Scroll.scroller.scrollTo("about_us", {
                  duration: 500,
                  smooth: "easeInOutQuad",
                });
              })}
            >
              About us
            </Nav.Link>
            <Nav.Link
              className={`${styles.nav_link}`}
              onClick={() => handleNavClick(() => {
                Scroll.scroller.scrollTo("rates", {
                  duration: 500,
                  smooth: "easeInOutQuad",
                  offset: -50,
                });
              })}
            >
              Today's Rates
            </Nav.Link>
            <Nav.Link
              className={`${styles.nav_link}`}
              onClick={() => handleNavClick(() => {
                Scroll.scroller.scrollTo("info", {
                  duration: 500,
                  smooth: "easeInOutQuad",
                  offset: -50,
                });
              })}
            >
              Benefits
            </Nav.Link>
            <Nav.Link
              className={`${styles.nav_link}`}
              onClick={() => handleNavClick(() => {
                Scroll.scroller.scrollTo("calc", {
                  duration: 500,
                  smooth: "easeInOutQuad",
                  offset: -50,
                });
              })}
            >
              Calculator
            </Nav.Link>
            <Nav.Link
              className={`${styles.nav_link}`}
              onClick={() => handleNavClick(() => {
                Scroll.scroller.scrollTo("gallery", {
                  duration: 500,
                  smooth: "easeInOutQuad",
                  offset: -50,
                });
              })}
            >
              Event Gallery
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <a
          href="https://www.swmc.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.sunwest_logo_link}`}
        >
          <Image
            src={imgCDNUrl + "header_new/sunwest_logo.svg"}
            fluid
            className={`${styles.header_image} ${styles.sunwest_logo}`}
          />
        </a>
      </Container>
      <div className="desktop-AccessibilityMenu-show">
            <UserWayAccessibilityMenu color="white" width={40} height={40}/>
          </div>
          </Navbar>
          <div className="mobile-AccessibilityMenu-show">
        <UserWayAccessibilityMenu color="white" width={40} height={40}/>
        </div>
      </>
  );
};

export default HeaderBar;
